import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAllAsync,
  fetchByFilterAsync,
  selectPortosAeroportos,
  selectPortosAeroportosByLocal,
} from '../../features/porto-aeroporto/PortoAeroportoSlice';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectPortoAeroportoAutocomplete({ label, name, initialValues, filter, ...restProps }) {
  const dispatch = useDispatch();

  const chaveLocal = filter?.local || 'ALL';

  const list = useSelector((state) => selectPortosAeroportosByLocal(state, chaveLocal));
  const fetchedRef = useRef({});   // { DESTINO: true, DESEMBARACO: true, ... } 
  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    if (fetchedRef.current[chaveLocal]) return; // já buscou este bucket
    fetchedRef.current[chaveLocal] = true;

    if (filter?.local) {
      dispatch(fetchByFilterAsync([{ name: 'local', value: filter.local }]));
    } else {
      // sem filtro: carrega tudo
      dispatch(fetchAllAsync());
    }
  }, [dispatch, chaveLocal, filter?.local]);

  useEffect(() => {
    const idSelecionado = _.get(initialValues, name);
    const found = list.find((item) => item?.id === idSelecionado) || { id: null, description: '' };

    setDefaultValue((prev) => (prev?.id === found?.id ? prev : found));
  }, [list, initialValues, name]);

  const filterOptions = createFilterOptions({
    stringify: (item) => (item?.description ? item?.description : ''),
  });

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (item?.description ? item?.description : '')}
      {...restProps}
    />
  );
}
